'use strict';

var addHuman = require('./addHuman'),
    addPlural = require('./addPlural'),
    addAcronym = require('./addAcronym'),
    defineAccessor = require('../../common/internal/defineAccessor'),
    namespaceAliases = require('../../common/var/namespaceAliases');

var sugarString = namespaceAliases.sugarString;

function buildInflectionAccessors() {
  defineAccessor(sugarString, 'addAcronym', addAcronym);
  defineAccessor(sugarString, 'addPlural', addPlural);
  defineAccessor(sugarString, 'addHuman', addHuman);
}

module.exports = buildInflectionAccessors;